import AgeVerify from "./Age";
import CodeVerify from "./Code";
import Game from "./Game";
import Intro from "./Intro";
import Leader from "./Leader";
import Menu from "./Menu";
import Privacy from "./Privacy";
import Register from "./Register";
import Score from "./Score";
import Start from "./Start";

export default class UI {
  constructor() {}
  init() {
    this.privacy = new Privacy();
    this.privacy.init();

    this.ageVerify = new AgeVerify();
    this.ageVerify.init();

    this.register = new Register();
    this.register.init();

    this.code = new CodeVerify();
    this.code.init();

    this.start = new Start();
    this.start.init();

    this.score = new Score();
    this.score.init();

    this.leader = new Leader();
    this.leader.init();

    this.intro = new Intro();
    this.intro.init();

    this.game = new Game();
    this.game.init();

    this.menu = new Menu();
    this.menu.init();
  }
}
